import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import SEO from "../../components/SEO";

const careersData = [
  {
    image: "/ai-idea.png",
    title: "AI Engineers",
    description:
      "Develop and enhance AI-driven financial solutions to improve lending processes.",
  },
  {
    image: "/credit.png",
    title: "Credit Analysts",
    description:
      "Assess creditworthiness and provide data-driven insights for better funding decisions.",
  },
  {
    image: "/marketing.png",
    title: "Marketing Experts",
    description:
      "Create and execute strategies to boost brand visibility and customer engagement.",
  },
  {
    image: "/target-or-bullseye.png",
    title: "Strategic Partnerships Specialists",
    description:
      "Build and manage key alliances to expand business opportunities.",
  },
  {
    image: "/business-center-outline.png",
    title: "Business Development Specialists",
    description:
      "Identify new markets, drive growth, and generate business leads.",
  },
];

const Careers = () => {
  return (
    <>
      <SEO
        title="Careers at Dequitec – Join Our MSME Loan Experts Team"
        description="Join Dequitec’s team of experts specializing in working capital loans and loan against property. Explore career opportunities with growth and innovation."
        canonical="https://www.dequitec.com/careers"
      />
      <Box sx={{ py: 4, px: 1 }}>
        {/* Career Banner Image */}
        <Box
          component="img"
          src="/CareerBanner Image.png"
          alt="Career Banner"
          width="100%"
          sx={{
            objectFit: { lg: "cover", xs: "contain" },
            height: { xs: "200px", md: "300px" },
          }}
        />

        {/* Section 1 */}
        <Grid
          container
          spacing={8}
          alignItems="center"
          justifyContent={"center"}
        >
          <Grid item xs={12} md={6} lg={3}>
            <Paper elevation={0} sx={{ borderRadius: 2, padding: 4 }}>
              <img
                src="/Careers.png"
                alt="Careers"
                style={{
                  height: "45vh",
                  borderRadius: "12px",
                  objectFit: "contain",
                  width: "100%",
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            {/* Centered Line & Title */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginBottom: "1%",
              }}
            >
              <Box
                sx={{
                  width: "40px",
                  height: "1px",
                  backgroundColor: "#004AAD",
                }}
              />
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", color: "#004AAD" }}
              >
                Join Our Team of Innovators!
              </Typography>
            </Box>
            <Typography variant="h6" gutterBottom>
              We are looking for best minds in finance and technology space for
              multiple positions
            </Typography>
            <Typography style={{ fontSize: "0.8rem", fontWeight: 100 }}>
              Excited to be part of Dequitec? Send your resume to
              careers@dequitec.com with the subject "Job Application - [Your
              Desired Position]" and take the next step in your career!
            </Typography>
          </Grid>
        </Grid>
        {/* Section 2 */}
        <Grid container spacing={4} justifyContent="center">
          {careersData.map((career, index) => (
            <Grid item xs={12} md={8} lg={10} key={index}>
              <Card
                sx={{
                  backgroundColor: "#F3F6F8",
                  p: 1,
                  borderRadius: 2,
                  boxShadow: 2,
                  display: "flex",
                  flexDirection: "row", // Ensure the layout is horizontal (row)
                  alignItems: "center", // Vertically aligns the image and text
                }}
              >
                <CardContent sx={{ textAlign: "left", paddingX: 3 }}>
                  {" "}
                  {/* Remove unnecessary padding */}
                  <CardMedia
                    component="img"
                    image={career.image}
                    alt={career.title}
                    sx={{
                      width: 40, // Adjust the image size as needed
                      height: 40, // Ensuring the image is consistent
                      ml: 1, // Adds spacing to the left of the image
                      mr: 2, // Adds spacing to the right of the image
                    }}
                  />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    color="text.primary"
                  >
                    {career.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    mt={0.5}
                    sx={{ fontStyle: "italic" }}
                  >
                    {career.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Careers;
